<template>
  <div v-if="permission && permission.version === '5'">
    <b-container fluid class="page_content" aria-label="Discover Page">
      <b-row class="explore_entity_result">
        <b-input-group>
          <template v-for="(idxSelected, index) in selectedFacets.indexesSelected" v-if="selectedFacets.indexesSelected">
            <div class="search_tag">
              <span class="title">{{formattedFacetName(idxSelected)}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('indexesSelected', index, idxSelected)">
              </span>
            </div>
          </template>
          <template v-for="(idxSelected, index) in selectedFacets.assetTypeSelected" v-if="selectedFacets.assetTypeSelected">
            <div class="search_tag">
              <span class="title">{{idxSelected}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('assetTypeSelected', index)">
              </span>
            </div>
          </template>
          <template v-for="(idxSelected, index) in selectedFacets.courseTypeSelected" v-if="selectedFacets.courseTypeSelected">
            <div class="search_tag">
              <span class="title">{{formattedFacetName(idxSelected)}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('courseTypeSelected', index)">
              </span>
            </div>
          </template>
          <template v-for="(idxSelected, index) in selectedFacets.jobTypeSelected" v-if="selectedFacets.jobTypeSelected">
            <div class="search_tag">
              <span class="title">{{idxSelected}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('jobTypeSelected', index)">
              </span>
            </div>
          </template>
          <template v-for="(idxSelected, index) in selectedFacets.personTypeSelected" v-if="selectedFacets.personTypeSelected">
            <div class="search_tag">
              <span class="title">{{idxSelected}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('personTypeSelected', index)">
              </span>
            </div>
          </template>
          <template v-for="(idxSelected, index) in selectedFacets.streamTypeSelected" v-if="selectedFacets.streamTypeSelected">
            <div class="search_tag">
              <span class="title">{{idxSelected}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('streamTypeSelected', index)">
              </span>
            </div>
          </template>
          <template v-for="(idxSelected, index) in selectedFacets.divisionTypeSelected" v-if="selectedFacets.divisionTypeSelected">
            <div class="search_tag">
              <span class="title">{{idxSelected}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('divisionTypeSelected', index)">
              </span>
            </div>
          </template>
          <template v-for="(idxSelected, index) in selectedFacets.departmentTypeSelected" v-if="selectedFacets.departmentTypeSelected">
            <div class="search_tag">
              <span class="title">{{idxSelected}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('departmentTypeSelected', index)">
              </span>
            </div>
          </template>
          <template v-for="(idxSelected, index) in selectedFacets.subjectTypeSelected" v-if="selectedFacets.subjectTypeSelected">
            <div class="search_tag">
              <span class="title">{{idxSelected}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('subjectTypeSelected', index)">
              </span>
            </div>
          </template>
          <template v-for="(idxSelected, index) in selectedFacets.creditTypeSelected" v-if="selectedFacets.creditTypeSelected">
            <div class="search_tag">
              <span class="title">{{idxSelected}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('creditTypeSelected', index)">
              </span>
            </div>
          </template>
          <template v-for="(idxSelected, index) in selectedFacets.levelTypeSelected" v-if="selectedFacets.levelTypeSelected">
            <div class="search_tag">
              <span class="title">{{idxSelected}}</span>
              <span class="ic_btn ic_bin" aria-label="delete" tabindex="0" @click.stop="removeSelectedFacet('levelTypeSelected', index)">
              </span>
            </div>
          </template>
        </b-input-group>
      </b-row>
      <b-row :class="[(
          (selectedFacets && selectedFacets.indexesSelected && selectedFacets.indexesSelected.length !== 0) ||
          (selectedFacets && selectedFacets.assetTypeSelected && selectedFacets.assetTypeSelected.length !== 0) ||
          (selectedFacets && selectedFacets.courseTypeSelected && selectedFacets.courseTypeSelected.length !== 0) ||
          (selectedFacets && selectedFacets.jobTypeSelected && selectedFacets.jobTypeSelected.length !== 0) ||
          (selectedFacets && selectedFacets.personTypeSelected && selectedFacets.personTypeSelected.length !== 0) ||
          (selectedFacets && selectedFacets.streamTypeSelected && selectedFacets.streamTypeSelected.length !== 0) ||
          (selectedFacets && selectedFacets.divisionTypeSelected && selectedFacets.divisionTypeSelected.length !== 0) ||
          (selectedFacets && selectedFacets.departmentTypeSelected && selectedFacets.departmentTypeSelected.length !== 0) ||
          (selectedFacets && selectedFacets.subjectTypeSelected && selectedFacets.subjectTypeSelected.length !== 0) ||
          (selectedFacets && selectedFacets.creditTypeSelected && selectedFacets.creditTypeSelected.length !== 0) ||
          (selectedFacets && selectedFacets.levelTypeSelected && selectedFacets.levelTypeSelected.length !== 0)) ? 'srh_tags_enable' : '']">
        <div cols="3" class="facets ace_sec" aria-label="facets section">
          <div class="main_head">
            <span class="icon-filter"></span>
            <span class="head_txt ace_sec_txt" role="heading" aria-lavel="1">Narrow Your Results</span>
          </div>
          <div class="facet_block_container">
            <div class="facet_block">
              <div class="head">
                <div class="checkbox">
                  <b-form-checkbox @change="actionForFolders" v-model="selectAllFolders" aria-label="select folders"></b-form-checkbox>
                </div>
                <div class="head_txt">Folders [{{ folders.length}}]</div>
                <div class="icon_container">
                  <b-btn v-b-toggle.myfolders>
                    <span class="collapsed icon-collapse" aria-label="collapse"><span class="visibility_hide">C</span></span>
                    <span class="expand icon-expand" aria-label="expand"><span class="visibility_hide">E</span></span>
                  </b-btn>
                </div>
              </div>
              <b-collapse visible id="myfolders">
                <div class="folder-section">
                  <div class="facet_row_container">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked :state="folderDeselect" v-model="foldersSelected" :options="folders" />
                    </b-form-group>
                  </div>
                </div>
              </b-collapse>
            </div>
            <!--
              <div class="facet_block">
                <div class="head">
                  <div class="checkbox">
                    <b-form-checkbox></b-form-checkbox>
                  </div>
                  <div class="head_txt">My Content</div>
                  <div class="icon_container">
                    <b-btn v-b-toggle.myContent>
                      <span class="collapsed icon-collapse" aria-label="collapse"><span class="visibility_hide">C</span></span>
                      <span class="expand icon-expand" aria-label="expand"><span class="visibility_hide">C</span></span>
                    </b-btn>
                  </div>
                </div>
                <b-collapse visible id="myContent">
                  <div class="facet_row_container">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="myContentSelected" :options="myContent" />
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
              -->
            <div class="entity-column">
              <div class="facet_block">
                <div class="head">
                  <div class="checkbox">
                    <b-form-checkbox
                      @change="selectAllEntitiesClicked"
                      aria-label="select all entity"
                      v-model="selectAllEntities">
                    </b-form-checkbox>
                  </div>
                  <div class="head_txt">
                    {{ $tf('entityType') }}
                  </div>
                  <div class="icon_container">
                    <b-btn v-b-toggle.entityType>
                      <span class="collapsed icon-collapse" aria-label="collapse"><span class="visibility_hide">C</span></span>
                      <span class="expand icon-expand" aria-label="expand"><span class="visibility_hide">C</span></span>
                    </b-btn>
                  </div>
                </div>
                <b-collapse visible id="entityType">
                  <div class="facet_row_container">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="indexesSelected" :options="indexes" @change="resetSubTypeFacetForEntity($event)"/>
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
              <div class="facet_block" v-if="isSelected('DeliveryContext') && courseType.length > 0">
                <div class="head">
                  <div class="checkbox">
                    <!--
                      <b-form-checkbox><label></label></b-form-checkbox>
                      -->
                  </div>
                  <div class="head_txt">Course Type</div>
                  <div class="icon_container">
                    <b-btn v-b-toggle.courseType>
                      <span class="collapsed icon-collapse" aria-label="collapse"><span class="visibility_hide">C</span></span>
                      <span class="expand icon-expand" aria-label="expand"><span class="visibility_hide">C</span></span>
                    </b-btn>
                  </div>
                </div>
                <b-collapse visible id="courseType">
                  <div class="facet_row_container">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="courseTypeSelected" :options="courseType" />
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
              <div class="facet_block" v-if="isSelected('LearningContent') && assetType.length > 0">
                <div class="head">
                  <div class="checkbox">
                    <!--
                      <b-form-checkbox><label></label></b-form-checkbox>
                      -->
                  </div>
                  <div class="head_txt">Asset Type</div>
                  <div class="icon_container">
                    <b-btn v-b-toggle.assetType>
                      <span class="collapsed icon-collapse" aria-label="collapse"><span class="visibility_hide">C</span></span>
                      <span class="expand icon-expand" aria-label="expand"><span class="visibility_hide">C</span></span>
                    </b-btn>
                  </div>
                </div>
                <b-collapse visible id="assetType">
                  <div class="facet_row_container">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="assetTypeSelected" :options="assetType" />
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
              <div class="facet_block" v-if="isSelected('Job')">
                <div class="head">
                  <div class="checkbox">
                  </div>
                  <div class="head_txt">Job Type</div>
                  <div class="icon_container">
                    <b-btn v-b-toggle.jobType>
                      <span class="collapsed icon-collapse" aria-label="collapse"><span class="visibility_hide">C</span></span>
                      <span class="expand icon-expand" aria-label="expand"><span class="visibility_hide">C</span></span>
                    </b-btn>
                  </div>
                </div>
                <b-collapse visible id="jobType">
                  <div class="facet_row_container">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="jobTypeSelected" :options="jobType" />
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
              <div class="facet_block" v-if="isSelected('Stream')  && streamType.length > 0">
                <div class="head">
                  <div class="checkbox">
                  </div>
                  <div class="head_txt">Tags</div>
                  <div class="icon_container">
                    <b-btn v-b-toggle.streamType>
                      <span class="collapsed icon-collapse" aria-label="collapse"><span class="visibility_hide">C</span></span>
                      <span class="expand icon-expand" aria-label="expand"><span class="visibility_hide">C</span></span>
                    </b-btn>
                  </div>
                </div>
                <b-collapse visible id="streamType">
                  <div class="facet_row_container">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="streamTypeSelected" :options="streamType" />
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
              <div class="facet_block" v-if="isSelected('Catalog')">
                <div class="head">
                  <div class="checkbox">
                  </div>
                  <div class="head_txt">Catalog Course</div>
                  <div class="icon_container">
                    <b-btn v-b-toggle.catalogCourseType>
                      <span class="collapsed icon-collapse" aria-label="collapse"><span class="visibility_hide">C</span></span>
                      <span class="expand icon-expand" aria-label="expand"><span class="visibility_hide">C</span></span>
                    </b-btn>
                  </div>
                </div>
                <b-collapse visible id="catalogCourseType">
                  <span class="subheading" v-if="divisionType.length > 0">Division</span>
                  <div class="facet_row_container" v-if="divisionType.length > 0">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="divisionTypeSelected" :options="divisionType" />
                    </b-form-group>
                  </div>
                  <span class="subheading" v-if="departmentType.length > 0">Department</span>
                  <div class="facet_row_container" v-if="departmentType.length > 0">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="departmentTypeSelected" :options="departmentType" />
                    </b-form-group>
                  </div>
                  <span class="subheading" v-if="subjectType.length > 0">Subject</span>
                  <div class="facet_row_container" v-if="subjectType.length > 0">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="subjectTypeSelected" :options="subjectType" />
                    </b-form-group>
                  </div>
                  <span class="subheading" v-if="creditType.length > 0">Credits</span>
                  <div class="facet_row_container" v-if="creditType.length > 0">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="creditTypeSelected" :options="creditType" />
                    </b-form-group>
                  </div>
                  <span class="subheading" v-if="levelType.length > 0">Level</span>
                  <div class="facet_row_container" v-if="levelType.length > 0">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="levelTypeSelected" :options="levelType" />
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
              <div class="facet_block" v-if="isSelected('Person') && personType.length > 0">
                <div class="head">
                  <div class="checkbox">
                  </div>
                  <div class="head_txt">Person Type</div>
                  <div class="icon_container">
                    <b-btn v-b-toggle.personType>
                      <span class="collapsed icon-collapse" aria-label="collapse"><span class="visibility_hide">C</span></span>
                      <span class="expand icon-expand" aria-label="expand"><span class="visibility_hide">C</span></span>
                    </b-btn>
                  </div>
                </div>
                <b-collapse visible id="personType">
                  <div class="facet_row_container">
                    <b-form-group>
                      <b-form-checkbox-group plain stacked v-model="personTypeSelected" :options="personType" />
                    </b-form-group>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
          <!-- facet_block_container -->
        </div>
        <!-- facets -->
        <div cols="9" class="datatable">
          <div class="list-header" style="height: 50px;">
            <div class="float-left" style="margin-top: 15px; margin-left: 14px;" v-if="results.length > 0">
              <div class="facet_list">
                <div class="checkbox ace_sec_txt">
                  <span class="form-checkbox">
                  <input type="checkbox" :disabled="permission.systemPermission.readOnly || isOnlyCourseFacetSelected" v-model="selectAllObjects" @click="actionForSelectAllObjects">
                  <i class="form-icon"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="right-container">
              <div class="out-of-total-item ace_sec_txt">
                <div>{{numberOfSelectedItems}} out of {{total}}</div>
              </div>
              <div class="number-of-item ace_sec_txt">
                <b-dropdown id="ddown-buttons" :text="''+size" :options="sizeOptions" aria-label="number of item">
                  <template v-for="(option, index) in sizeOptions">
                    <b-dropdown-divider v-if="index > 0"></b-dropdown-divider>
                    <b-dropdown-item @click="changeSize(option)">{{option}}</b-dropdown-item>
                  </template>
                </b-dropdown>
              </div>
              <div class="pagination btn_container pagination_sty3">
                <button type="button" class="btn btn_trans" :disabled="pageNumber <= 1" @click="prevPage" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                <span class="current-page ace_sec_txt">{{pageNumber}}</span>
                <button type="button" class="btn btn_trans" :disabled="(from + size) >= total" @click="nextPage" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
              </div>
              <template v-if="!(permission.systemPermission.readOnly || isStudentLogin)">
                <div class="ic_bin ace_sec_txt" @click="showDeleteConfirmBox" aria-label="delete" :class="[((selectedUuids.length === 0) || (!isBulkDeleteSelected && isBulkCopyMoveSelected)) ? 'disable' : '']" v-b-popover.hover.top="'Courses can not be deleted from here'"></div>
                <div class="more-link ace_sec_txt" :class="[((selectedUuids.length === 0) || (isMixedEntitySelected && !isBulkCopyMoveSelected) || (isBulkDeleteSelected && !isBulkCopyMoveSelected)) ? 'disable' : '']">
                  <b-dropdown text="more" :disabled="((selectedUuids.length === 0) || (isMixedEntitySelected && !isBulkCopyMoveSelected) || (isBulkDeleteSelected && !isBulkCopyMoveSelected))" v-b-popover.hover.top="''">
                    <b-dropdown-item @click="openCopyMoveFolderSelectionPopup('Copy')">copy</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="openCopyMoveFolderSelectionPopup('Move')">move</b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </div>
          </div>
          <template v-if="(bulkDeleteCount > size || bulkCopyMoveCount > size)">
            <div v-if="!isStudentLogin && selectAllObjects" class="bulk-operation-info">
              <b-row>
                <div class="w-100 text-center mt-1">
                  <span v-if="isOnlyAssetFacetSelected">
                    <template v-if="bulkDeleteCount > size">
                      <template v-if="!isBulkDeleteSelected">
                        Select all <a href="javascript://" @click="selectionForCopyMoveDelete" style="color: #1A73E8;">{{bulkDeleteCount}} assets for copy/move/delete</a>
                      </template>
                      <template v-else>
                        All {{bulkDeleteCount}} assets are selected for copy/move/delete. <a href="javascript://" @click="clearBulkSelection" style="color: #1A73E8;">Clear selection</a>
                      </template>
                    </template>
                  </span>
                  <span v-else>
                    <template v-if="!(isBulkDeleteSelected || isBulkCopyMoveSelected)">
                      <template v-if="bulkDeleteCount > size">Select all <a href="javascript://" @click="isBulkDeleteSelected = true" style="color: #1A73E8;">{{bulkDeleteCount}} entities for delete</a></template><template v-if="bulkCopyMoveCount > size"> OR <a href="javascript://" @click="isBulkCopyMoveSelected = true" style="color: #1A73E8;">{{bulkCopyMoveCount}} entities for copy/move</a></template>
                    </template>
                    <template v-else-if="isBulkDeleteSelected">
                      All {{bulkDeleteCount}} entities are selected for delete. <a href="javascript://" @click="clearBulkSelection" style="color: #1A73E8;">Clear selection</a>
                    </template>
                    <template v-else-if="isBulkCopyMoveSelected">
                      All {{bulkCopyMoveCount}} entities are selected for copy/move. <a href="javascript://" @click="clearBulkSelection" style="color: #1A73E8;">Clear selection</a>
                    </template>
                  </span>
                </div>
              </b-row>
            </div>
          </template>
          <b-row class="search_result_container">
            <b-col cols="12">
              <b-list-group>
                <template v-if="results.length === 0">
                  <div class="msg_no_result ace_sec_txt">
                    No results found!
                  </div>
                </template>
                <template v-else>
                  <b-list-group-item class="flex-column align-items-start result_row" v-for="(result, index) in formattedResults">
                    <div :key="result.uuid">
                      <div class="facet_list">
                        <div class="checkbox ace_sec_txt">
                          <span class="form-checkbox">
                          <input type="checkbox" :aria-labelledby="'entity_' + index" :value="result.uuid" :disabled="(result.resourceType === 'deliverycontext') || permission.systemPermission.readOnly" v-model="selectedUuids" @change="itemCheckboxToggle($event, result)">
                          <i class="form-icon"></i>
                          </span>
                        </div>
                      </div>
                      <div class="result_block">
                        <div class="d-flex w-100">
                          <div class="title_icon">
                            <div v-if="result.resourceType === 'deliverycontext'" class="icon-course" aria-label="asset"></div>
                            <div v-if="result.resourceType === 'learningtopic'" class="ic24-microCompetency" aria-label="microcompetency"></div>
                            <div v-if="result.resourceType === 'stream'" class="icon-stream float-left" aria-label="stream"></div>
                            <div v-if="result.resourceType === 'catalog'" class="ico-catalog float-left" aria-label="catalog"></div>
                            <div v-if="result.resourceType === 'job'" class="ico-job2 float-left" aria-label="job"></div>
                            <div v-if="result.resourceType === 'club'" class="ico-club float-left" aria-label="club"></div>
                            <div v-if="result.resourceType === 'event'" class="fas fa-calendar-alt float-left" aria-label="event"></div>
                            <div v-if="result.resourceType === 'person'" class="fas ico-mentor float-left" aria-label="person"></div>
                            <div v-if="result.fileType === 'assessment'" class="icon-assessment float-left" aria-label="assessment"></div>
                            <div v-if="result.fileType === 'video'" class="icon-video float-left" aria-label="video"></div>
                            <div v-if="result.fileType === 'scorm'" class="icon-scorm float-left" aria-label="scorm" style="font-size: 35px; color: #b8652a;"></div>
                            <div v-if="result.fileType === 'pdf'" class="icon-file-pdf float-left" aria-label="pdf"></div>
                            <div v-if="result.fileType === 'txt'" class="icon-file-text float-left" aria-label="txt file"></div>
                            <div v-if="result.fileType === 'csv'" class="icon-csvFile float-left" aria-label="csv"></div>
                            <div v-if="result.fileType === 'mp4' || result.fileType === 'mp3'" class="icon-video float-left" aria-label="video"></div>
                            <div v-if="result.fileType === 'zip'" class="icon-file-zip float-left" aria-label="zip"></div>
                            <div v-if="result.fileType === 'doc' || result.fileType === 'docx'" class="icon-file-word float-left" aria-label="doc"></div>
                            <div v-if="result.fileType === 'slideshare'" class="icon-asset float-left" aria-label="slide share"></div>
                            <div v-if="result.fileType === 'xlsx' || result.fileType === 'xls'" class="icon-file-excel float-left" aria-label="excel"></div>
                            <div v-if="result.fileType === 'pptx' || result.fileType === 'ppt'" class="icon-pagePPT float-left" aria-label="ppt"></div>
                            <div v-if="result.fileType === 'html' || result.fileType === 'externalurl'" class="icon-pageURL float-left" aria-label="external url"></div>
                            <div v-if="result.fileType === 'jpg' || result.fileType === 'jpeg' || result.fileType === 'png' || result.fileType === 'gif'" class="icon-image float-left" aria-label="image"></div>
                            <div v-if="result.fileType === 'other'" class="icon-asset float-left" aria-label="other"></div>
                          </div>
                          <div class="title ace_sec_txt" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" :id="'entity_' + index"> {{ result.title }} </div>
                          <template v-if="result.master">
                            <div class="icon-master" style="margin-top: 4px !important;" :aria-label="$t('aria.nav.masterCourse')" :title="$t('tooltip.masterCourse')" v-b-tooltip.hover>m</div>
                          </template>
                          <small style="display: none;">{{result.lastUpdatedTime}}</small>
                        </div>
                        <div class="result_block_row description_row ace_sec_txt">
                          <div class="icon_container">
                            <span class="icon-paragraph-left"></span>
                          </div>
                          <div class="title_new" v-if="result.description">
                            <v-clamp class="title_txt" autoresize :max-lines="2">{{ result.description }}</v-clamp>
                          </div>
                          <div v-else class="no-description">
                            <template v-if="result.type === 'RICH_HTML'">No description available for this content</template>
                            <template v-else>No description added for this content</template>
                          </div>
                        </div>
                        <div class="result_block_row auto_extracted_info">
                          <div class="icon_container">
                            <span class="icon-extract"></span>
                          </div>
                          <div class="details ace_sec_txt">
                            <div class="tags">
                              <div class="no_tags"></div>
                            </div>
                            <span class="icon-pencil2 ace_sec_txt" v-on:click="showTagsPopup()"></span>
                          </div>
                        </div>
                        <div class="result_block_row tags_row">
                          <div class="icon_container">
                            <span class="ic-tag"></span>
                          </div>
                          <div class="details ace_sec_txt">
                            <template v-if="result && ((result.appliedTagMap && Object.values(result.appliedTagMap).some(t => t && t.length > 0)) || (result.careerCompetenciesList && result.careerCompetenciesList.length > 0))">
                              <div class="tags_container">
                                <div class="tags_cat" v-if="result.appliedTagMap" :id="'tagsRow_' + index">
                                  <template v-for="(values, key) in result.appliedTagMap">
                                    <div class="tag" v-for="tag in values" @blur="getTagContainerRowWidth('tagsRow_' + index)" :aria-label="tag.name + '. tag'" tabindex="0">
                                      <span class="tag_name instructional_tag" :title="tag.name">{{tag.name}}</span>
                                    </div>
                                  </template>
                                </div>
                                <div class="tags_cat" v-if="result.careerCompetenciesList && result.careerCompetenciesList.length > 0" :id="'specialTagsRow_' + index">
                                  <div class="tag" v-for="specialTag in result.careerCompetenciesList" @blur="getTagContainerRowWidth('specialTagsRow_' + index)" :class="specialTag.tagType" :aria-label="specialTag.name + '. tag'" tabindex="0">
                                    <span class="tag_name competency_tag" data-toggle="tooltip" data-placement="top" :title="specialTag.name">{{specialTag.name}}</span>
                                    <span class="tag_lavel" v-if="specialTag.fulfillLevels.length > 0">
                                    {{specialTag.fulfillLevels[0]}}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <b-button class="btn ic_btn btn_ellipsis"
                                v-if="result && (result.appliedTagMap || (result.careerCompetenciesList && result.careerCompetenciesList.length > 0))"
                                @click="showTagsPopup('tagsRow_', 'specialTagsRow_', index)"
                                aria-label="show all tags"
                                title="show all tags"
                                v-b-tooltip.hover
                                tabindex="0">
                                <span class="module_icon ic9-iconMore-0005 ic_more"></span>
                              </b-button>
                            </template>
                            <template v-else>
                              <div class="no_tags">
                                <div class="empty_pattern ace_sec_txt" aria-label="No tag added for this entity">
                                  No tag added for this entity
                                </div>
                              </div>
                            </template>
                            <b-button class="btn ic_btn ic-edit"
                              v-if="canApplyTag(result.ownerId, result)" v-on:click="showAddTagPopup(result, $event)"
                              title="edit tags"
                              v-b-tooltip.hover
                              tabindex="0">
                            </b-button>
                          </div>
                        </div>
                      </div>
                      <div class="thumbnail ace_sec_txt">
                        <div v-if="result.resourceType === 'deliverycontext'">
                          <div class="thumbnail_default icon-course" @click="redirectToResult(result)" aria-label="course"></div>
                        </div>
                        <div v-if="result.resourceType === 'stream'">
                          <div class="thumbnail_default icon-stream" @click="redirectToResult(result)" aria-label="stream"></div>
                        </div>
                        <div v-if="result.resourceType === 'catalog'">
                          <div class="thumbnail_default ico-catalog" @click="redirectToResult(result)" aria-label="catalog"></div>
                        </div>
                        <div v-if="result.resourceType === 'job'">
                          <div class="thumbnail_default ico-job2" @click="redirectToResult(result)" aria-label="job"></div>
                        </div>
                        <div v-if="result.resourceType === 'club'">
                          <div class="thumbnail_default ico-club" @click="redirectToResult(result)" aria-label="club"></div>
                        </div>
                        <div v-if="result.resourceType === 'event'">
                          <div class="thumbnail_default fas fa-calendar-alt" @click="redirectToResult(result)" aria-label="event"></div>
                        </div>
                        <div v-if="result.resourceType === 'person'">
                          <div class="thumbnail_default ico-mentor" @click="redirectToResult(result)" aria-label="person"></div>
                        </div>
                        <div v-if="result.fileType === 'assessment'">
                          <div class="thumbnail_default icon-assessment" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="assessment"></div>
                        </div>
                        <div v-if="result.fileType === 'video'">
                          <div class="thumbnail_default icon-video" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="video"></div>
                        </div>
                        <div v-if="result.fileType === 'pdf'">
                          <div class="thumbnail_default icon-file-pdf" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="pdf"></div>
                        </div>
                        <div v-if="result.fileType === 'txt'">
                          <div class="thumbnail_default icon-file-text" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="txt file"></div>
                        </div>
                        <div v-if="result.fileType === 'csv'">
                          <div class="thumbnail_default icon-csvFile" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="csv"></div>
                        </div>
                        <div v-if="result.fileType === 'mp4' || result.fileType === 'mp3'">
                          <div class="thumbnail_default icon-video" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="video"></div>
                        </div>
                        <div v-if="result.fileType === 'zip'">
                          <div class="thumbnail_default icon-file-zip" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="zip"></div>
                        </div>
                        <div v-if="result.fileType === 'doc' || result.fileType === 'docx'" aria-label="doc">
                          <div class="thumbnail_default icon-file-word" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)"></div>
                        </div>
                        <div v-if="result.fileType === 'xlsx'">
                          <div class="thumbnail_default icon-file-excel" aria-label="excel" @contextmenu="openInNewTab($event, result)"></div>
                        </div>
                        <div v-if="result.fileType === 'ppt' || result.fileType === 'pptx'">
                          <div class="thumbnail_default icon-pagePPT" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="ppt"></div>
                        </div>
                        <div v-if="result.fileType === 'html' || result.fileType === 'externalurl'">
                          <div class="thumbnail_default icon-pageURL" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="url"></div>
                        </div>
                        <div v-if="result.fileType === 'jpg' || result.fileType === 'jpeg' || result.fileType === 'png' || result.fileType === 'gif'">
                          <div class="thumbnail_default icon-image" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="image"></div>
                        </div>
                        <div v-if="result.fileType === 'slideshare'">
                          <div class="thumbnail_default icon-asset" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="image"></div>
                        </div>
                        <div v-if="result.fileType === 'other'">
                          <div class="thumbnail_default icon-asset" @click="redirectToResult(result)" @contextmenu="openInNewTab($event, result)" aria-label="other"></div>
                        </div>
                      </div>
                    </div>
                  </b-list-group-item>
                  <template>
                    <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
                  </template>
                </template>
              </b-list-group>
            </b-col>
          </b-row>
        </div>
        <div>
          <b-modal ref="tagsListPopup" :title="'Tags'" class="modal__v22_2" size="lg" hide-header-close no-close-on-backdrop no-close-on-esc centered>

            <div slot="modal-header" class="row header-section w-100">
    					<div class="col-11 hd">
    						<div class="ic_container">
                  <span class="ic ic-tag"></span>
    						</div>
    						<div class="hd_txt">
    							<span>Tags</span>
    						</div>
    					</div>
    					<div class="col-1 btn_container pr-0 mt-0">
    						<button class="btn_close" aria-label="close" @click="closeTagsPopup">
    							 <span class="ic-close"></span>
    						</button>
    					</div>
    				</div>

            <div class="details">
              <div class="tags_container" id="tagsListContainer">
              </div>
            </div>

            <div slot="modal-footer" class="w-100">
              <div class="btn_container">
                <b-button type="button" class="btn" @click="closeTagsPopup">ok</b-button>
              </div>
            </div>
          </b-modal>
        </div>

        <div>
          <b-modal ref="deleteConfirmModal" :title="'Please Confirm!'" :header-bg-variant="'discover-content-delete-modal'" hide-header-close no-close-on-backdrop no-close-on-esc centered>
            <div style="text-align: center;">
              <template v-if="isBulkDeleteSelected">
                <h6>Are you sure you want to delete: </h6>
                <h6>({{bulkDeleteCount}}) <template v-if="isOnlyAssetFacetSelected">Assets</template><template v-else>entities</template></h6>
              </template>
              <template v-else>
                <h6>Are you sure you want to delete: </h6>
                <h6 v-if="formattedSelectedItems.assets.length > 0">({{formattedSelectedItems.assets.length}}) Assets</h6>
                <h6 v-if="formattedSelectedItems.topics.length > 0">({{formattedSelectedItems.topics.length}}) Topics</h6>
                <h6 v-if="formattedSelectedItems.streams.length > 0">({{formattedSelectedItems.streams.length}}) Streams</h6>
                <h6 v-if="formattedSelectedItems.catalogs.length > 0">({{formattedSelectedItems.catalogs.length}}) Catalogs</h6>
                <h6 v-if="formattedSelectedItems.jobs.length > 0">({{formattedSelectedItems.jobs.length}}) Jobs</h6>
                <h6 v-if="formattedSelectedItems.clubs.length > 0">({{formattedSelectedItems.clubs.length}}) Clubs</h6>
                <h6 v-if="formattedSelectedItems.events.length > 0">({{formattedSelectedItems.events.length}}) Events</h6>
                <h6 v-if="formattedSelectedItems.persons.length > 0">({{formattedSelectedItems.persons.length}}) Persons</h6>
                <h6 v-if="formattedSelectedItems.courses.length > 0">
                  Course cannot be deleted from here. To delete the course go to "Course" link under "Administer" menu
                </h6>
              </template>
            </div>
            <div slot="modal-footer" class="w-100">
              <b-button @click="deleteItems" class="btn button-primary next float-right mr-2"> yes </b-button>
              <b-button @click="cancelDeleteAsset" class="btn button-primary next float-right mr-2"> no </b-button>
            </div>
          </b-modal>
        </div>
        <div>
          <b-modal ref="copyFolderSelectionModal" :title="'Copy Selected Contents To'" :header-bg-variant="'discover-content-delete-modal'" hide-header-close no-close-on-backdrop no-close-on-esc centered>
            <div style="text-align: center;">
              <div class="heading border-0 float-left ml-5">
                <label for="copiedFolder" id="copyFolderDestination">Destination</label>
              </div>
              <div class="folder-name float-left ml-4">
                <select id="copiedFolder" v-model="destination" aria-labelledby="copyFolderDestination">
                  <option v-for="folder in copyMoveDestinationFolders" :value="{uuid: folder.uuid, displayName: folder.displayName}">{{ folder.displayName }}</option>
                </select>
              </div>
            </div>
            <div slot="modal-footer" class="w-100">
              <b-button @click="copyMoveAsset('Copy')" class="btn button-primary next float-right mr-2"> ok </b-button>
              <b-button @click="closeCopyMoveAsset('Copy')" class="btn button-primary next float-right mr-2"> cancel </b-button>
            </div>
          </b-modal>
        </div>
        <div>
          <b-modal ref="moveFolderSelectionModal" :title="'Move Selected Contents To'" :header-bg-variant="'discover-content-delete-modal'" hide-header-close no-close-on-backdrop no-close-on-esc centered>
            <div style="text-align: center;">
              <div class="heading border-0 float-left ml-5">
                <label for="movedFolder" id="moveFolderDestination">Destination</label>
              </div>
              <div class="folder-name float-left ml-4">
                <select id="movedFolder" v-model="destination" aria-labelledby="moveFolderDestination">
                  <option v-for="folder in copyMoveDestinationFolders" :value="{uuid: folder.uuid, displayName: folder.displayName}">{{ folder.displayName }}</option>
                </select>
              </div>
            </div>
            <div slot="modal-footer" class="w-100">
              <b-button @click="copyMoveAsset('Move')" class="btn button-primary next float-right mr-2"> ok </b-button>
              <b-button @click="closeCopyMoveAsset('Move')" class="btn button-primary next float-right mr-2"> cancel </b-button>
            </div>
          </b-modal>
        </div>
        <div class="loading-spinner">
          <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF; overflow: hidden;">
              <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
              <div class="mt-4" v-if="loadingMessage">
                <span>{{loadingMessage}}</span>
              </div>
            </div>
          </b-modal>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import AddTagPopup from '../../tagging/components/AddTagPopup'
  import { getSimpleLibraryFilter } from '../searchUtils.js'
  import '../../../assets/module/sass/discover/discover.scss'
  import { EntityUtil } from '../../../entityUtils'
  import { PACKAGE } from '../../../package_constants'
  import VClamp from 'vue-clamp'
  import _ from 'lodash'

  export default {
    name: 'results',
    props: [],
    components: {
      AddTagPopup,
      VClamp
    },
    data: () => {
      return {
        hasLoadedOnce: false,
        selectAllFolders: true,
        selectAllEntities: false,
        folders: [],
        allFolders: [],
        foldersSelected: [],
        privateLibraryList: [],
        publicLibraryList: [],
        selectedUuids: [],
        selectedObjects: [],
        selectAllObjects: false,
        userId: '',
        userRole: '',
        libraryList: '',
        indexes: [
          {
            text: 'Stream [0]',
            value: 'Stream',
            checked: true
          },
          {
            text: 'Catalog [0]',
            value: 'Catalog',
            checked: true
          },
          {
            text: 'Course [0]',
            value: 'DeliveryContext',
            checked: true
          },
          {
            text: 'MicroCompetency [0]',
            value: 'LearningTopic',
            checked: true
          },
          {
            text: 'Asset [0]',
            value: 'LearningContent',
            checked: true
          },
          {
            text: 'Job [0]',
            value: 'Job',
            checked: true
          },
          {
            text: 'Club [0]',
            value: 'Club',
            checked: true
          },
          {
            text: 'Event [0]',
            value: 'Event',
            checked: true
          },
          {
            text: 'Person [0]',
            value: 'Person',
            checked: true
          }
        ],
        indexesSelected: [],
        /*
        allIndexes: ['deliverycontext', 'learningcontent', 'learningtopic', 'stream', 'job', 'catalog', 'event', 'club', 'person'],
        */
        allIndexes: ['deliverycontext', 'learningcontent', 'learningtopic', 'stream', 'catalog', 'event', 'club', 'person'],
        myContent: [
          {
            text: 'Owned by Me',
            value: 'myContent',
            checked: true
          },
          {
            text: 'Shared with Me',
            value: 'sharedContent',
            checked: true
          }
        ],
        myContentSelected: ['myContent', 'sharedContent'],
        assetType: [],
        assetTypeSelected: [],
        courseType: [],
        courseTypeSelected: [],
        jobType: [],
        jobTypeSelected: [],
        streamType: [],
        streamTypeSelected: [],
        divisionType: [],
        divisionTypeSelected: [],
        departmentType: [],
        departmentTypeSelected: [],
        subjectType: [],
        subjectTypeSelected: [],
        creditType: [],
        creditTypeSelected: [],
        levelType: [],
        levelTypeSelected: [],
        personType: [],
        personTypeSelected: [],
        indexList: '',
        facets: {},
        filter: {},
        query: {},
        source: ['title', 'uuid', 'name', 'description', 'type', 'fileType', 'creationTime', 'lastUpdatedTime', 'thumbnail', 'thumbnailURI', 'thumbnailURIList', 'uri', '_score', 'appliedTagMap', 'aggregatedAppliedTags', 'fileType', 'originUuid', 'master', 'careerCompetenciesMap', 'careerCompetenciesList', 'ownerId', 'ownerName'],
        sizeOptions: [ 10, 50, 100 ],
        ignoreFolderWatch: false,
        ignoreCourseWatch: false,
        ignoreAssetWatch: false,
        ignoreJobWatch: false,
        ignoreStreamWatch: false,
        ignoreDivisionWatch: false,
        ignoreDepartmentWatch: false,
        ignoreSubjectWatch: false,
        ignoreCreditWatch: false,
        ignoreLevelWatch: false,
        ignorePersonWatch: false,
        destination: {},
        copyMoveDestinationFolders: [],
        resultsSnapshot: [],
        isShowTagPopup: false,
        taggingEntityData: {},
        loadingMessage: null,
        isBulkDeleteSelected: false,
        isBulkCopyMoveSelected: false
      }
    },

    computed: {
      ...mapState({
        'results': state => state.search.results,
        'total': state => state.search.total,
        'from': state => state.search.from,
        'pageNumber': state => state.search.pageNumber,
        'size': state => state.search.size,
        'sort': state => state.search.sort,
        'facetResults': state => state.search.aggregations,
        'isResetSelectedItems': state => state.search.isResetSelectedItems,
        'libraryPositionMapping': state => state.search.libraryPositionMapping,
        'userObj': state => state.user.userObj,
        'permission': state => state.user.permission,
        'selectedIndexes': state => state.search.selectedIndexes,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'selectedFacets': state => state.search.selectedFacets
      }),
      bulkDeleteCount () {
        if (this.facetResults && this.facetResults.type) {
          let typeTerms = this.facetResults.type.termObj.buckets || []
          let course = _.find(typeTerms, (type) => {
            return (type.key === 'DeliveryContext')
          })
          return course ? (this.total - course.doc_count) : this.total
        }
        return 0
      },
      bulkCopyMoveCount () {
        if (this.facetResults && this.facetResults.type) {
          let typeTerms = this.facetResults.type.termObj.buckets || []
          let asset = _.find(typeTerms, (type) => {
            return (type.key === 'LearningContent')
          })
          return asset ? asset.doc_count : 0
        }
        return 0
      },
      isOnlyCourseFacetSelected () {
        return ((this.indexesSelected.length === 1) && (this.indexesSelected[0] === 'DeliveryContext'))
      },
      isOnlyAssetFacetSelected () {
        return ((this.indexesSelected.length === 1) && (this.indexesSelected[0] === 'LearningContent'))
      },
      isMixedEntitySelected () {
        let mixedSelection = _.filter(this.selectedObjects, (item) => {
          return (item.resourceType !== 'learningcontent')
        })
        return ((this.selectedUuids.length > 0) && (mixedSelection.length > 0))
      },
      isTimeViewEnabled () {
        let timeViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TIME_VIEW_FEATURE_ID]
        if (timeViewFeature && timeViewFeature.enabled) {
          return true
        }
        return false
      },
      searchTerms () {
        return this.terms
      },
      numberOfSelectedItems () {
        return this.selectedUuids.length
      },
      folderDeselect () {
        if (this.foldersSelected.length === this.folders.length) {
          this.selectAllFolders = true
        } else {
          this.selectAllFolders = false
        }
      },
      formattedSelectedItems () {
        let formattedItems = {
          'assets': [],
          'topics': [],
          'courses': [],
          'streams': [],
          'catalogs': [],
          'jobs': [],
          'clubs': [],
          'events': [],
          'persons': []
        }
        let selectedObjects = this.selectedObjects
        selectedObjects.forEach((obj) => {
          if (obj.resourceType === 'deliverycontext') {
            formattedItems.courses.push(obj)
          } else if (obj.resourceType === 'learningtopic') {
            formattedItems.topics.push(obj)
          } else if (obj.resourceType === 'learningcontent') {
            formattedItems.assets.push(obj)
          } else if (obj.resourceType === 'stream') {
            formattedItems.streams.push(obj)
          } else if (obj.resourceType === 'catalog') {
            formattedItems.catalogs.push(obj)
          } else if (obj.resourceType === 'job') {
            formattedItems.jobs.push(obj)
          } else if (obj.resourceType === 'club') {
            formattedItems.clubs.push(obj)
          } else if (obj.resourceType === 'event') {
            formattedItems.events.push(obj)
          } else if (obj.resourceType === 'person') {
            formattedItems.persons.push(obj)
          }
        })
        return formattedItems
      },
      isIndexFacetsSelected () {
        let selectedIndexes = this.selectedIndexes
        return selectedIndexes && selectedIndexes.length > 0
      },
      formattedResults () {
        let formatted = []
        let results = this.results
        if (!this.results || !this.results.length || this.results.length <= 0) {
          return []
        }
        results.forEach(result => {
          formatted.push(result)
        })
        return formatted
      },
      isStudentLogin () {
        return (localStorage.getItem('userrole') === 'Student')
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.query._) {
          this.populateUserLibrary()
        }
        if (from.path !== to.path) {
          this.indexesSelected = []
        }
      },
      facetResults (newFacet) {
        // do not clear the facet results after the first load
        if (!this.hasLoadedOnce) {
          this.resetFacets()
        }

        // process library
        var libTerms = this.facetResults.library.termObj.buckets || []
        var lib = {}
        for (let i = 0; i < libTerms.length; i++) {
          lib = libTerms[i]
          for (let j = 0; j < this.folders.length; j++) {
            if (this.folders[j].value === lib.key) {
              this.folders[j].text = this.folders[j].text.substr(0, this.folders[j].text.indexOf('[')) + ' [' + lib.doc_count + ']'
            }
          }
        }

        // process content type
        var typeTerms = this.facetResults.type.termObj.buckets || []
        var type = {}
        this.indexes.forEach((item, i) => {
          let notFound = true
          for (let j = 0; j < typeTerms.length; j++) {
            type = typeTerms[j]
            if (item.value === type.key) {
              notFound = false
              item.text = item.text.substr(0, item.text.indexOf(' ')) + ' [' + type.doc_count + ']'
            }
          }
          if (notFound) {
            let key = item.text.substr(0, item.text.indexOf(' '))
            if (this.indexesSelected.length > 0) {
              if (this.indexesSelected.includes(key)) {
                item.text = key + ' [0]'
              }
            } else {
              item.text = key + ' [0]'
            }
          }
        })

        // process asset type
        var assetTerms = this.facetResults.assetType.termObj.buckets || []
        this.assetType = []
        var asset = {}
        for (let i = 0; i < assetTerms.length; i++) {
          asset = {
            'text': assetTerms[i].key + ' [' + assetTerms[i].doc_count + ']',
            'value': assetTerms[i].key
          }
          this.assetType.push(asset)
        }

        // process course type
        if (this.facetResults.courseType) {
          this.courseType = []
          var courseTypeTerms = this.facetResults.courseType.termObj.buckets
          for (let i = 0; i < courseTypeTerms.length; i++) {
            const courseTypeTerm = courseTypeTerms[i]
            const text = (courseTypeTerm.key === 1) ? 'Master' : 'Section'
            const iconMaster = (text === 'Master') ? '<div class="icon-master" style="position: absolute; right: 75px; top: 0;" title="master course" v-b-tooltip.hover>m</div>' : ''
            var courseSectionTypeTerm = {
              'text': text + ' [' + courseTypeTerm.doc_count + ']' + iconMaster,
              'value': (text === 'Master')
            }
            this.courseType.push(courseSectionTypeTerm)
          }
        }

        let facetResults = this.facetResults
        let processFacetResult = this.processFacetResult
        processFacetResult(facetResults.jobType, 'jobType')
        processFacetResult(facetResults.aggregatedAppliedTags, 'streamType')
        processFacetResult(facetResults.catalogCourseDivision, 'divisionType')
        processFacetResult(facetResults.catalogCourseDepartment, 'departmentType')
        processFacetResult(facetResults.catalogCourseSubject, 'subjectType')
        processFacetResult(facetResults.catalogCourseCredit, 'creditType')
        processFacetResult(facetResults.catalogCourseLevel, 'levelType')
        processFacetResult(facetResults.personType, 'personType')
      },
      foldersSelected (newFoldersSelected) {
        if (this.ignoreFolderWatch) {
          this.ignoreFolderWatch = false
        } else {
          this.updateFacet()
        }
      },
      indexesSelected (newIndexesSelected) {
        this.updateFacet()
        this.storeSelectedFactes({key: 'indexesSelected', value: this.indexesSelected})
      },
      courseTypeSelected (newCourseTypeSelected) {
        if (this.ignoreCourseWatch) {
          this.ignoreCourseWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'courseTypeSelected', value: this.courseTypeSelected})
        }
      },
      assetTypeSelected (newAssetTypeSelected) {
        if (this.ignoreAssetWatch) {
          this.ignoreAssetWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'assetTypeSelected', value: this.assetTypeSelected})
        }
      },
      jobTypeSelected (newJobTypeSelected) {
        if (this.ignoreJobWatch) {
          this.ignoreJobWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'jobTypeSelected', value: this.jobTypeSelected})
        }
      },
      streamTypeSelected (newStreamTypeSelected) {
        if (this.ignoreStreamWatch) {
          this.ignoreStreamWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'streamTypeSelected', value: this.streamTypeSelected})
        }
      },
      divisionTypeSelected (newDivisionTypeSelected) {
        if (this.ignoreDivisionWatch) {
          this.ignoreDivisionWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'divisionTypeSelected', value: this.divisionTypeSelected})
        }
      },
      departmentTypeSelected (newDepartmentTypeSelected) {
        if (this.ignoreDepartmentWatch) {
          this.ignoreDepartmentWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'departmentTypeSelected', value: this.departmentTypeSelected})
        }
      },
      subjectTypeSelected (newSubjectTypeSelected) {
        if (this.ignoreSubjectWatch) {
          this.ignoreSubjectWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'subjectTypeSelected', value: this.subjectTypeSelected})
        }
      },
      creditTypeSelected (newCreditTypeSelected) {
        if (this.ignoreCreditWatch) {
          this.ignoreCreditWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'creditTypeSelected', value: this.creditTypeSelected})
        }
      },
      levelTypeSelected (newLevelTypeSelected) {
        if (this.ignoreLevelWatch) {
          this.ignoreLevelWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'levelTypeSelected', value: this.levelTypeSelected})
        }
      },
      personTypeSelected (newPersonTypeSelected) {
        if (this.ignorePersonWatch) {
          this.ignorePersonWatch = false
        } else {
          this.updateFacet()
          this.storeSelectedFactes({key: 'personTypeSelected', value: this.personTypeSelected})
        }
      },
      isResetSelectedItems (newValue) {
        if (this.isResetSelectedItems) {
          this.selectedUuids = []
          this.selectedObjects = []
          this.updateResetSelectedItems(false)
        }
      }
    },
    updated () {
      // this.showEllipsisTags()
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.showEllipsisTags()
        })
      })
    },
    mounted () {
      this.loadPermission().then(res => {
        this.getLibraryPositionMapping()
        this.populateUserLibrary()
      })
    },
    methods: {
      ...mapActions([
        'loadUserInfo',
        'loadSearchResults',
        'loadAllLibraryForUser',
        'constructSearchQuery',
        'deleteSelectedContent',
        'deleteSelectedTopic',
        'deleteSelectedStreams',
        'deleteSelectedCatalogs',
        'deleteSelectedJobs',
        'deleteSelectedClubs',
        'deleteSelectedEvents',
        'deleteSelectedPersons',
        'updateFrom',
        'updatePageNumber',
        'updateSize',
        'updateResetSelectedItems',
        'loadLibraryPositionMapping',
        'execCopyMoveSelectedContent',
        'loadPermission',
        'updateSelectedIndexes',
        'loadLogDashboardActivity',
        'storeSelectedFactes',
        'constructSearchQueryForBulkOperation'
      ]),
      populateUserLibrary () {
        this.showLoader()
        this.userId = localStorage.getItem('userid')
        this.userRole = localStorage.getItem('userrole')
        this.setupUserLibraries()
      },
      getLibraryPositionMapping () {
        this.loadLibraryPositionMapping()
      },
      populateCopyMoveDestinations () {
        this.loadAllLibraryForUser().then(libraries => {
          var folders = this.sortLibrariesIntoStandardOrder(libraries)
          if (folders && folders.length > 0) {
            for (var i = (folders.length - 1); i >= 0; i--) {
              let folder = folders[i]
              let permission = folder.acelist[0].permission
              if (!permission || !permission.folderPermission || !permission.folderPermission.allowedAsDestinationFolder) {
                folders.splice(i, 1)
              }
            }
            this.copyMoveDestinationFolders = folders
          }
        })
      },
      resetDestinationSelection () {
        if (this.copyMoveDestinationFolders.length > 0) {
          let folder = this.copyMoveDestinationFolders[0]
          this.destination = {uuid: folder.uuid, displayName: folder.displayName}
        }
      },
      sortLibrariesIntoStandardOrder (libraries) {
        var sortedLibraryList = []
        for (var attr in this.libraryPositionMapping) {
          var value = this.libraryPositionMapping[attr]
          for (var i = 0; i < libraries.length; i++) {
            var library = libraries[i]
            if (this.libraryMatches(library, value)) {
              sortedLibraryList.push(library)
            }
          }
        }
        return sortedLibraryList
      },
      libraryMatches (library, value) {
        if (library.category === 'LearningSpace') {
          if (library.title === 'Shared With Me') {
            if (value === 'Shared') {
              return true
            }
          } else {
            if (value === 'Global') {
              return true
            }
          }
        }
        return library.category.indexOf(value) !== -1
      },
      actionForFolders () {
        this.foldersSelected = []
        if (this.selectAllFolders === false) {
          this.folders.forEach((folder) => {
            this.foldersSelected.push(folder.value)
          })
        }
      },
      selectAllEntitiesClicked () {
        let indexesSelected = []
        this.indexes.forEach(function (index) {
          indexesSelected.push(index.value.slice())
        })
        if (!this.selectAllEntities) {
          this.indexesSelected = indexesSelected
        } else {
          this.indexesSelected = []
        }
      },
      updateFacet () {
        this.showLoader()
        this.updatePageNumber(1)
        this.updateFrom(0)
        this.constructQuery()
      },
      showEllipsisTags () {
        $('.tag-row').each(function () {
          var rowId = this.id
          var rowHeight = $('#' + rowId).height()
          if (rowHeight > 37) {
            $('#' + rowId + '.ellipsisTags').show()
          } else {
            $('#' + rowId + '.ellipsisTags').hide()
          }
        })
      },
      setupUserLibraries () {
        let userPreferences = {}
        let selectedLearningSpaces = []
        this.loadUserInfo().then(res => {
          userPreferences = res.userPreferences
          selectedLearningSpaces = userPreferences.learningSpaces
          this.loadAllLibraryForUser().then(libraries => {
            this.folders = []
            this.allFolders = []
            this.foldersSelected = []
            this.publicLibraryList = []
            this.privateLibraryList = []
            this.ignoreFolderWatch = true
            let learningSpaces = this.sortLibrariesIntoStandardOrder(libraries)
            if (learningSpaces && learningSpaces.length > 0) {
              for (var i = 0; i < learningSpaces.length; i++) {
                let learningSpace = learningSpaces[i]
                const category = learningSpace.category
                if (category === 'LearningSpace' || category === 'Institute_Public' || category === 'User_Private') {
                  this.folders.push({value: learningSpace.uuid, text: learningSpace.displayName + '[0]'})
                  this.ignoreFolderWatch = true
                  this.allFolders.push(learningSpace.uuid)
                  if (selectedLearningSpaces.includes(learningSpace.uuid)) {
                    this.foldersSelected.push(learningSpace.uuid)
                  }
                  if (category !== 'Institute' && category !== 'User_Private') {
                    this.publicLibraryList.push(learningSpace.uuid)
                  }
                  if (category === 'User_Private') {
                    this.privateLibraryList.push(learningSpace.uuid)
                  }
                }
                let permission = learningSpace.acelist[0].permission
                if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
                  this.copyMoveDestinationFolders.push(learningSpace)
                }
              }
              this.$nextTick(() => {
                this.$nextTick(() => {
                  this.populateSelectedFacetsFromState()
                })
              })
            }
            this.constructQuery()
          })
        })
      },
      resetFacets () {
        this.indexes = [
          {
            text: 'Stream [0]',
            value: 'Stream',
            checked: true
          },
          {
            text: 'Catalog [0]',
            value: 'Catalog',
            checked: true
          },
          {
            text: 'Course [0]',
            value: 'DeliveryContext',
            checked: true
          },
          {
            text: 'MicroCompetency [0]',
            value: 'LearningTopic',
            checked: true
          },
          {
            text: 'Asset [0]',
            value: 'LearningContent',
            checked: true
          },
          {
            text: 'Club [0]',
            value: 'Club',
            checked: true
          },
          {
            text: 'Event [0]',
            value: 'Event',
            checked: true
          },
          {
            text: 'Person [0]',
            value: 'Person',
            checked: true
          }
        ]

        for (var i = 0; i < this.folders.length; i++) {
          this.folders[i].text = this.folders[i].text.substr(0, this.folders[i].text.indexOf('[')) + ' [0]'
        }
      },
      showLoader (message) {
        if (this.$refs.loadingModal) {
          this.loadingMessage = message
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.loadingMessage = null
          this.$refs.loadingModal.hide()
        }
        if (!this.hasLoadedOnce) {
          this.hasLoadedOnce = true
        }
      },
      redirectToResult (result) {
        if (result.resourceType === 'deliverycontext') {
          this.$store.commit('LOAD_COURSE', {})
          this.$store.commit('LOAD_CLASS_SUMMARY', {})
          this.$store.commit('LOAD_COURSE_TOPICS', {})
          this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
          return this.$router.push({name: 'courseDashboard', params: { uuid: result.uuid }})
        } else if (result.resourceType === 'learningcontent') {
          this.$store.commit('LOAD_ENTITY_DETAIL', {})
          if (result.fileType === 'assessment') {
            return this.$router.push({ name: 'assessmentDetail', params: { uuid: result.uuid } })
          }
          return this.$router.push({name: 'assetPreview', params: { uuid: result.uuid }})
        }else if (result.resourceType === 'learningtopic') {
          return this.$router.push({name: 'microCompetencyEdit', params: { uuid: result.uuid }})
        } else if (result.resourceType === 'stream') {
          if (this.isTimeViewEnabled) {
            return this.$router.push({ name: 'streamTime', params: { uuid: result.uuid } })
          } else {
            return this.$router.push({ name: 'streamPlanner', params: { uuid: result.uuid } })
          }
        } else if (result.resourceType === 'job') {
          return this.$router.push({name: 'jobHome', params: { uuid: result.uuid }})
        } else if (result.resourceType === 'catalog') {
          return this.$router.push({name: 'catalogDetail', params: { uuid: result.uuid }})
        } else if (result.resourceType === 'event') {
          return this.$router.push({name: 'eventDetail', params: { uuid: result.uuid }})
        } else if (result.resourceType === 'club') {
          return this.$router.push({name: 'clubDetail', params: { uuid: result.uuid }})
        } else if (result.resourceType === 'person') {
          return this.$router.push({name: 'personDetail', params: { uuid: result.uuid }})
        }

        // TODO is there a person detail page to route to?
        // else if (result.resourceType === 'person') {
        //   return this.$router.push({name: 'personDetail', params: { uuid: result.uuid }})
        // }
      },
      openInNewTab (ev, result) {
        if (result.resourceType === 'learningcontent') {
          this.$store.commit('LOAD_ENTITY_DETAIL', {})
          let name = (result.fileType === 'assessment') ? 'assessmentDetail' : 'assetPreview'
          let router = this.$router.resolve({name: name, params: {uuid: result.uuid}})
          window.open(router.href, '_blank')
          ev.preventDefault()
        }
      },
      changeSize (option) {
        this.updateSize(option)
        this.updateFrom(0)
        this.updatePageNumber(1)
        this.constructQuery()
      },
      showTagsPopup (tagsRow, specialTagsRow, index) {
        this.$refs.tagsListPopup.show()
        let tagsRowId = tagsRow + index
        let tagsList = $('#' + tagsRowId).html()
        let specialTagsRowId = specialTagsRow + index
        let specialTagsList = $('#' + specialTagsRowId).html()
        $('#tagsListContainer').html(tagsList).append(specialTagsList)
      },
      closeTagsPopup () {
        this.$refs.tagsListPopup.hide()
      },
      canApplyTag (ownerId, entity) {
        return EntityUtil.canEdit(ownerId, entity)
      },
      showAddTagPopup (result, event) {
        this.isShowTagPopup = true
        let type = 'none'
        if (result.resourceType === 'stream') {
          type = 'stream'
        } else if (result.resourceType === 'catalog') {
          type = 'catalog'
        } else if (result.resourceType === 'deliverycontext') {
          type = 'course'
        } else if (result.resourceType === 'learningtopic') {
          type = 'topics'
        } else if (result.resourceType === 'learningcontent') {
          type = 'assets'
        } else if (result.resourceType === 'job') {
          type = 'job'
        } else if (result.resourceType === 'club') {
          type = 'club'
        } else if (result.resourceType === 'event') {
          type = 'event'
        } else if (result.resourceType === 'person') {
          type = 'person'
        }
        let appliedTagMap = result.appliedTagMap || {}
        let careerCompetenciesMap = result.careerCompetenciesMap || {}
        let careerCompetenciesList = result.careerCompetenciesList || []
        this.taggingEntityData = {uuid: result.uuid, title: result.title, type: type, appliedTagMap: appliedTagMap, careerCompetenciesMap: careerCompetenciesMap, careerCompetenciesList: careerCompetenciesList, isRefresh: true}
        setTimeout(() => {
          this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
        }, 500)
      },
      actionForSelectAllObjects () {
        this.selectedUuids = []
        this.selectedObjects = []
        this.isBulkDeleteSelected = false
        this.isBulkCopyMoveSelected = false
        if (!this.selectAllObjects) {
          for (let i in this.formattedResults) {
            let item = this.formattedResults[i]
            if (item.resourceType !== 'deliverycontext') {
              this.selectedObjects.push(item)
              this.selectedUuids.push(item.uuid)
            }
          }
        }
      },
      itemCheckboxToggle (ev, item) {
        if (ev.target.checked) {
          this.selectedObjects.push(item)
          if (this.selectedUuids.length === this.size) {
            this.selectAllObjects = true
          }
        } else {
          this.selectAllObjects = false
          const index = this.selectedObjects.indexOf(item)
          this.selectedObjects.splice(index, 1)
        }
      },
      selectionForCopyMoveDelete () {
        this.isBulkDeleteSelected = true
        this.isBulkCopyMoveSelected = true
      },
      clearBulkSelection () {
        this.selectedUuids = []
        this.selectedObjects = []
        this.selectAllObjects = false
        this.isBulkDeleteSelected = false
        this.isBulkCopyMoveSelected = false
      },
      showDeleteConfirmBox () {
        if (this.selectedUuids.length > 0 && (this.isBulkDeleteSelected || !this.isBulkCopyMoveSelected)) {
          this.$refs.deleteConfirmModal.show()
        }
      },
      tryDeleteWithNotify (deleteFunction, objectsToDelete, objectType) {
        if (!deleteFunction || !objectsToDelete || !objectsToDelete.length || objectsToDelete.length <= 0 || !objectType) {
          return
        }

        let uuids = []
        let loggedActionName = 'delete' + objectType
        let loadLogDashboardActivity = this.loadLogDashboardActivity
        objectsToDelete.forEach((obj) => {
          uuids.push(obj.uuid)
          loadLogDashboardActivity({action: loggedActionName, page: 'discover', link: '', entityUuid: obj.uuid})
        })

        deleteFunction(uuids).then(res => {
          this.closeAndResetSelection()
          if (res) {
            if (res.succeeded > 0) {
              let message = '' + res.succeeded + ' ' + objectType + ' (s) deleted successfully.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
              }, 0)
            }
            if (res.unauthorized > 0) {
              let message = '' + res.unauthorized + ' ' + objectType + ' not deleted due to lack of permission.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'warn',
                  title: '',
                  text: message
                })
              }, 500)
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: objectType + ' deletion failed due to a network issue.'
            })
          }
          setTimeout(() => {
            this.constructQuery()
          }, 1000)
        })
      },
      async deleteItems () {
        if (this.isBulkDeleteSelected) {
          this.closeAndResetSelection()
          let resp = await this.constructSearchQueryForBulkOperation({from: 0, size: this.bulkDeleteCount, userId: this.userId, operation: 'DELETE'})
          return this.$router.push({name: 'taskMonitor', params: {taskId: resp.taskId}})
        } else {
          this.showLoader()
          let deleteAsset = this.deleteSelectedContent
          let deleteTopic = this.deleteSelectedTopic
          let deleteStream = this.deleteSelectedStreams
          let deleteCatalog = this.deleteSelectedCatalogs
          let deleteJob = this.deleteSelectedJobs
          let deleteClub = this.deleteSelectedClubs
          let deleteEvent = this.deleteSelectedEvents
          let deletePerson = this.deleteSelectedPersons

          this.tryDeleteWithNotify(deleteAsset, this.formattedSelectedItems.assets, 'Asset')
          this.tryDeleteWithNotify(deleteTopic, this.formattedSelectedItems.topics, 'Topic')
          this.tryDeleteWithNotify(deleteStream, this.formattedSelectedItems.streams, 'Stream')
          this.tryDeleteWithNotify(deleteCatalog, this.formattedSelectedItems.catalogs, 'Catalog')
          this.tryDeleteWithNotify(deleteJob, this.formattedSelectedItems.jobs, 'Job')
          this.tryDeleteWithNotify(deleteClub, this.formattedSelectedItems.clubs, 'Club')
          this.tryDeleteWithNotify(deleteEvent, this.formattedSelectedItems.events, 'Event')
          this.tryDeleteWithNotify(deletePerson, this.formattedSelectedItems.persons, 'Person')
        }
      },
      cancelDeleteAsset () {
        this.closeAndResetSelection()
      },
      getTagContainerRowWidth (rowId) {
        let tagContainerWidth = $('#' + rowId).innerWidth()
        return tagContainerWidth
      },
      closeAndResetSelection () {
        this.clearBulkSelection()
        this.$refs.deleteConfirmModal.hide()
      },
      prevPage () {
        if (this.pageNumber >= 1 && (this.from - this.size) >= 0) {
          this.updatePageNumber(this.pageNumber - 1)
          this.updateFrom(this.from - this.size)
          this.constructQuery(false)
        }
      },
      nextPage () {
        if ((this.from + this.size) < this.total) {
          this.updatePageNumber(this.pageNumber + 1)
          this.updateFrom(this.from + this.size)
          this.constructQuery(false)
        }
      },
      openCopyMoveFolderSelectionPopup (action) {
        this.resetDestinationSelection()
        if (action === 'Copy') {
          this.$refs.copyFolderSelectionModal.show()
        } else if (action === 'Move') {
          this.$refs.moveFolderSelectionModal.show()
        }
      },
      closeCopyMoveAsset (action) {
        if (action === 'Copy') {
          this.$refs.copyFolderSelectionModal.hide()
        } else if (action === 'Move') {
          this.$refs.moveFolderSelectionModal.hide()
        }
        this.clearBulkSelection()
      },
      async copyMoveAsset (action) {
        if (this.isBulkCopyMoveSelected) {
          this.isBulkCopyMoveSelected = false
          this.closeCopyMoveAsset(action)
          let resp = await this.constructSearchQueryForBulkOperation({from: 0, size: this.bulkCopyMoveCount, userId: this.userId, operation: action.toUpperCase(), targetLibraryId: this.destination.uuid})
          return this.$router.push({name: 'taskMonitor', params: {taskId: resp.taskId}})
        } else {
          const contentIds = this.selectedUuids
          if (contentIds.length > 0) {
            this.showLoader('It will take sometime. Please be patient.')
            this.closeCopyMoveAsset(action)
            this.execCopyMoveSelectedContent({uuids: contentIds, targetLibraryId: this.destination.uuid, action: action}).then(res => {
              var type = 'error'
              var status = res.status
              var message = action + ' operation failed: Network or Server Error [status code: ' + status + ']'
              if (status === 200) {
                var failures = res.data
                if (failures.length > 0) {
                  if (failures.length === contentIds.length) {
                    message = action + ' operation failed: Not authorized'
                  } else {
                    type = 'warn'
                    const count = (contentIds.length - failures.length)
                    console.log('failures: ', failures)
                    const failed = action + ' operation failed for ' + failures.length + ' asset(s): Not authorized.'
                    const success = count + ' Asset(s) ' + ((action === 'Copy') ? 'copied' : 'moved') + ' successfully in the selected library: ' + this.destination.displayName
                    message = success + '<BR>' + failed
                  }
                } else {
                  type = 'success'
                  message = contentIds.length + ' Asset(s) ' + ((action === 'Copy') ? 'copied' : 'moved') + ' successfully in the selected library: ' + this.destination.displayName
                }
              }
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: type,
                  title: '',
                  text: message
                })
                this.hideLoader()
                return this.$router.push({name: 'results', query: {_: new Date().getTime()}})
              }, 2000)
            })
          }
        }
      },
      resetLocalFields () {
        this.indexList = []
        this.libraryList = []
        this.selectedUuids = []
        this.selectedObjects = []
        this.selectAllObjects = false
        this.isBulkDeleteSelected = false
        this.isBulkCopyMoveSelected = false
      },
      buildFacet (field, size, order) {
        let filterField = field.split('.')[0]
        return {
          'aggs': {
            'termObj': {
              'terms': {
                'field': field,
                'size': size,
                'order': order
              }
            }
          },
          'filter': this.getFacetFilter(filterField)
        }
      },
      processFacetResult (facetResult, facetListName) {
        if (!facetResult) {
          return
        }
        this[facetListName] = []
        let terms = facetResult.termObj.buckets
        for (var i = 0; i < terms.length; i++) {
          let term = {
            'text': terms[i].key + '[' + terms[i].doc_count + ']',
            'value': terms[i].key
          }
          this[facetListName].push(term)
        }
      },
      async constructQuery () {
        this.resetLocalFields()
        // construct the libraryList
        for (var i = 0; i < this.allFolders.length; i++) {
          if (this.libraryList.length === 0) {
            this.libraryList = this.allFolders[i]
          } else {
            this.libraryList = this.libraryList + ',' + this.allFolders[i]
          }
        }
        // construct the indexList
        for (i = 0; i < this.allIndexes.length; i++) {
          if (this.indexList.length === 0) {
            this.indexList = this.allIndexes[i]
          } else {
            this.indexList = this.indexList + ',' + this.allIndexes[i]
          }
        }

        let buildFacet = this.buildFacet
        // construct facets
        this.facets = {
          'library': {
            'aggs': {
              'termObj': {
                'terms': {
                  'field': 'owningLibraryId.keyword',
                  'size': 100
                }
              }
            },
            'filter': this.getFacetFilter('owningLibraryId')
          },
          'type': {
            'aggs': {
              'termObj': {
                'terms': {
                  'field': '_type'
                }
              }
            },
            'filter': this.getFacetFilter('_type')
          },
          'courseType': {
            'aggs': {
              'termObj': {
                'terms': {
                  'field': 'master',
                  'order': {'_key': 'desc'}
                }
              }
            },
            'filter': this.getFacetFilter('master')
          },
          'assetType': buildFacet('fileType.keyword', 100, {'_key': 'asc'}),
          'jobType': buildFacet('jobTypes.raw', 100, {'_key': 'asc'}),
          'aggregatedAppliedTags': buildFacet('aggregatedAppliedTags.tagNames.keyword', 100, {'_key': 'asc'}),
          'catalogCourseDivision': buildFacet('division', 50, {'_key': 'asc'}),
          'catalogCourseDepartment': buildFacet('department', 50, {'_key': 'asc'}),
          'catalogCourseSubject': buildFacet('subject', 50, {'_key': 'asc'}),
          'catalogCourseCredit': buildFacet('catalogCourseCredits.keyword', 50, {'_key': 'asc'}),
          'catalogCourseLevel': buildFacet('level.keyword', 50, {'_key': 'asc'}),
          'personType': buildFacet('personType.keyword', 50, {'_key': 'asc'})
        }
        this.filter = this.generateFilter()
        let results = await this.constructSearchQuery({ terms: undefined, sort: this.sort, source: this.source, from: this.from, size: this.size, indexList: this.indexList, libraryList: this.libraryList, privateLibraryList: this.privateLibraryList, publicLibraryList: this.publicLibraryList, userId: this.userId, aggs: this.facets, filter: this.filter })
        this.resultsSnapshot = (results && results.length > 0) ? results : []
        this.$forceUpdate()
        if (this.isIndexFacetsSelected) {
          await this.searchOnSelectedIndexes()
        }
        this.hideLoader()
      },
      async searchOnSelectedIndexes () {
        // clear the state so these facets are not selected on every page visit
        let selectedIndexes = this.selectedIndexes.slice(0)
        this.updateSelectedIndexes([])
        // trigger another search on the selected index facets if preselected
        this.indexesSelected = selectedIndexes
      },
      generateFilter () {
        // let userId = this.userId
        // origin UUID
        var filterObj = {
          'bool': this.originUuidCheck()
        }

        // Folders
        if (this.foldersSelected.length > 0) {
          let orQuery = {
            'bool': {
              'should': [
                getSimpleLibraryFilter(this.foldersSelected)
              ]
            }
          }
          filterObj.bool.must.push(orQuery)
        } else {
          let selected = []
          this.folders.forEach((folder) => {
            selected.push(folder.value)
          })
          let orQuery = {
            'bool': {
              'should': [
                getSimpleLibraryFilter(selected)
              ]
            }
          }
          filterObj.bool.must.push(orQuery)
        }

        // Content Type
        if (this.indexesSelected.length > 0) {
          let terms = {
            'terms': {
              '_type': this.indexesSelected
            }
          }
          filterObj.bool.must.push(terms)
        }
        // Course Type
        if (this.courseTypeSelected.length > 0 && this.indexesSelected.indexOf('DeliveryContext') !== -1) {
          let terms = {
            'terms': {
              'master': this.courseTypeSelected
            }
          }
          filterObj.bool.must.push(terms)
        } else {
          this.ignoreCourseWatch = true
          this.courseTypeSelected = []
        }
        // Asset Type
        if (this.assetTypeSelected.length > 0 && this.indexesSelected.indexOf('LearningContent') !== -1) {
          let terms = {
            'terms': {
              'fileType': this.assetTypeSelected
            }
          }
          filterObj.bool.must.push(terms)
        } else {
          this.ignoreAssetWatch = true
          this.assetTypeSelected = []
        }

        // Job Type
        if (this.jobTypeSelected.length > 0 && this.indexesSelected.indexOf('Job') !== -1) {
          let terms = {
            'terms': {
              'jobTypes.raw': this.jobTypeSelected
            }
          }
          filterObj.bool.must.push(terms)
        } else {
          this.ignoreJobWatch = true
          this.jobTypeSelected = []
        }

        // Stream Type
        if (this.streamTypeSelected.length > 0 && this.indexesSelected.indexOf('Stream') !== -1) {
          let terms = {
            'terms': {
              'aggregatedAppliedTags.tagNames': this.streamTypeSelected
            }
          }
          filterObj.bool.must.push(terms)
        } else {
          this.ignoreStreamWatch = true
          this.streamTypeSelected = []
        }

        // Division Type
        if (this.divisionTypeSelected.length > 0 && this.indexesSelected.indexOf('Catalog') !== -1) {
          let terms = {
            'terms': {
              'division': this.divisionTypeSelected
            }
          }
          filterObj.bool.must.push(terms)
        } else {
          this.ignoreDivisionWatch = true
          this.divisionTypeSelected = []
        }

        // Department Type
        if (this.departmentTypeSelected.length > 0 && this.indexesSelected.indexOf('Catalog') !== -1) {
          let terms = {
            'terms': {
              'department': this.departmentTypeSelected
            }
          }
          filterObj.bool.must.push(terms)
        } else {
          this.ignoreDepartmentWatch = true
          this.departmentTypeSelected = []
        }

        // Subject Type
        if (this.subjectTypeSelected.length > 0 && this.indexesSelected.indexOf('Catalog') !== -1) {
          let terms = {
            'terms': {
              'subject': this.subjectTypeSelected
            }
          }
          filterObj.bool.must.push(terms)
        } else {
          this.ignoreSubjectWatch = true
          this.subjectTypeSelected = []
        }

        // Credit Type
        if (this.creditTypeSelected.length > 0 && this.indexesSelected.indexOf('Catalog') !== -1) {
          let terms = {
            'terms': {
              'catalogCourseCredits': this.creditTypeSelected
            }
          }
          filterObj.bool.must.push(terms)
        } else {
          this.ignoreCreditWatch = true
          this.creditTypeSelected = []
        }

        // Level Type
        if (this.levelTypeSelected.length > 0 && this.indexesSelected.indexOf('Catalog') !== -1) {
          let terms = {
            'terms': {
              'level': this.levelTypeSelected
            }
          }
          filterObj.bool.must.push(terms)
        } else {
          this.ignoreLevelWatch = true
          this.levelTypeSelected = []
        }

        // Person Type
        if (this.personTypeSelected.length > 0 && this.indexesSelected.indexOf('Person') !== -1) {
          let terms = {
            'terms': {
              'personType.keyword': this.personTypeSelected
            }
          }
          filterObj.bool.must.push(terms)
        } else {
          this.ignorePersonWatch = true
          this.personTypeSelected = []
        }
        return filterObj
      },
      getFacetFilter (facetType) {
        // let userId = this.userId
        let facetFilterObj = {
          'bool': this.originUuidCheck()
        }

        if (facetType === 'owningLibraryId') {
          facetFilterObj.bool.must.push(getSimpleLibraryFilter(this.allFolders))
        } else if (facetType !== 'enrolledCourses') {
          if (this.foldersSelected.length > 0) {
            let orQuery = {
              'bool': {
                'should': [
                  getSimpleLibraryFilter(this.foldersSelected)
                ]
              }
            }
            facetFilterObj.bool.must.push(orQuery)
          } else {
            let selected = []
            this.folders.forEach((folder) => {
              selected.push(folder.value)
            })
            let orQuery = {
              'bool': {
                'should': [
                  getSimpleLibraryFilter(selected)
                ]
              }
            }
            facetFilterObj.bool.must.push(orQuery)
          }
          if (this.indexesSelected && this.indexesSelected.length > 0) {
            let terms = {
              'terms': {
                '_type': this.indexesSelected
              }
            }
            facetFilterObj.bool.must.push(terms)
          }
        }
        return facetFilterObj
      },
      originUuidCheck () {
        var originUuidCheck = {
          'must': [],
          'must_not': {
            'exists': {
              'field': 'originUuid'
            }
          }
        }
        return originUuidCheck
      },
      isSelected (entity) {
        let selected = false
        this.indexesSelected.forEach((index) => {
          if (index === entity) {
            selected = true
          }
        })
        return selected
      },
      populateSelectedFacetsFromState () {
        this.indexesSelected = this.selectedFacets.indexesSelected || []
        this.courseTypeSelected = this.selectedFacets.courseTypeSelected || []
        this.assetTypeSelected = this.selectedFacets.assetTypeSelected || []
        this.jobTypeSelected = this.selectedFacets.jobTypeSelected || []
        this.personTypeSelected = this.selectedFacets.personTypeSelected || []
        this.streamTypeSelected = this.selectedFacets.streamTypeSelected || []
        this.divisionTypeSelected = this.selectedFacets.divisionTypeSelected || []
        this.departmentTypeSelected = this.selectedFacets.departmentTypeSelected || []
        this.subjectTypeSelected = this.selectedFacets.subjectTypeSelected || []
        this.creditTypeSelected = this.selectedFacets.creditTypeSelected || []
        this.levelTypeSelected = this.selectedFacets.levelTypeSelected || []
      },
      formattedFacetName (key) {
        let data = {'DeliveryContext': 'Course', 'LearningContent': 'Asset', true: 'Master', false: 'Section'}
        return data[key] || key
      },
      resetSubTypeFacetForEntity (indexes) {
        this.indexesSelected.forEach((name, i) => {
          if (!indexes.includes(name)) {
            this.removeSelectedFacet('indexesSelected', i, name)
          }
        })
      },
      removeSelectedFacet (key, index, name) {
        switch (key) {
          case 'indexesSelected':
            this.indexesSelected.splice(index, 1)
            if (name) {
              if (name === 'DeliveryContext') {
                this.courseTypeSelected.splice(0, this.courseTypeSelected.length)
              }
              else if (name === 'LearningContent') {
                this.assetTypeSelected.splice(0, this.assetTypeSelected.length)
              }
              else if (name === 'Job') {
                this.jobTypeSelected.splice(0, this.jobTypeSelected.length)
              }
              else if (name === 'Person') {
                this.personTypeSelected.splice(0, this.personTypeSelected.length)
              }
              else if (name === 'Catalog') {
                this.divisionTypeSelected.splice(0, this.divisionTypeSelected.length)
                this.departmentTypeSelected.splice(0, this.departmentTypeSelected.length)
                this.subjectTypeSelected.splice(0, this.subjectTypeSelected.length)
                this.creditTypeSelected.splice(0, this.creditTypeSelected.length)
                this.levelTypeSelected.splice(0, this.levelTypeSelected.length)
              }
            }
            break
          case 'assetTypeSelected':
            this.assetTypeSelected.splice(index, 1)
            break
          case 'courseTypeSelected':
            this.courseTypeSelected.splice(index, 1)
            break
          case 'jobTypeSelected':
            this.jobTypeSelected.splice(index, 1)
            break
          case 'personTypeSelected':
            this.personTypeSelected.splice(index, 1)
            break
          case 'streamTypeSelected':
            this.streamTypeSelected.splice(index, 1)
            break
          case 'divisionTypeSelected':
            this.divisionTypeSelected.splice(index, 1)
            break
          case 'departmentTypeSelected':
            this.departmentTypeSelected.splice(index, 1)
            break
          case 'subjectTypeSelected':
            this.subjectTypeSelected.splice(index, 1)
            break
          case 'creditTypeSelected':
            this.creditTypeSelected.splice(index, 1)
            break
          case 'levelTypeSelected':
            this.levelTypeSelected.splice(index, 1)
            break
        }
      }
    }
  }
</script>

<style scoped>
	.collapsed > .collapsed,
	:not(.collapsed) > .expand {
	  display: none;
	}

  .description_row {
    height: 48px;
  }

	.tag-row {
		float:left;
		max-width: calc(100% - 79px);
		white-space: nowrap;
    overflow: hidden;
    margin-top: 2px;
	}

	.ellipsisTags {
		float: left;
		cursor:pointer;
		background: #ededed;
	}

	.tag-popup .tag-box-list {
		border: 1px solid #e6e6e6 !important;
		height: 82px !important;
	}

	.tag-popup .footer-section {
		margin-right: 7px;
		margin-bottom: 10px;
	}

  .explore_entity_result .input-group .search_tag .title {
    background-color: #bee4e6;
  }

  .bulk-operation-info {
    background: #d9d9d9;
    margin-top: -10px;
    margin-left: 1px;
    height: 30px;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/app/search/components/Results.vue